import React from 'react'
import cx from 'classnames'
import VisibilitySensor from 'react-visibility-sensor'
import jump from 'jump.js'
import FlexSearch from 'flexsearch'
import { find } from 'lodash'

import PageLink from '@/link.js'
import Image from '@/image.js'

import { Search, MiniArrow } from '@/svgs.js'

import SearchIndex from '../../../static/search.json'

class CategoriesZone extends React.Component {
  constructor () {
    super()
    this.state = {
      active: 'category',
      selectedCategory: 0,
      selectedSticker: 0,
      fixed: false,
      bottom: false,
      navOpen: false,
      query: ''
    }

    this.form = React.createRef()
    this.index = new FlexSearch({
      doc: {
        id: "id",
        field: [
          "body",
          "title",
          "slug"
        ]
      }
    })
    SearchIndex.forEach(item => {
      this.index.add(item)
    })
    this.brandNav = React.createRef()
  }
  componentDidMount () {
    console.log('scrollto', this.props.scrollState)
    if (this.props.scrollState) {
      setTimeout(() => {
        jump(`.${this.props.scrollState.toLowerCase()}`, {
          offset: -100
        })
      }, 1300)
    }
  }
  searchJazz(e) {
    e.preventDefault()
    e.stopPropagation()
    const form = this.form.current
    this.index.search({
      query: form.search.value,
      depth: 3,
      threshold: 5
    }, (result) => {
      this.setState({
        results: result
      })
    })
    this.setState({
      query: form.search.value
    })
  }
  shiftZone (category) {
    jump('.js-top-brand', {
      offset: -200,
      duration: 500,
      callback: () => {
        this.setState({
          active: category,
        })
      }
    })
  }
  handleCategory(e, i) {
    if (e) {
      this.setState({
        selectedCategory: i
      })
    }
  }
  handleSticker(e, i) {
    if (e) {
      this.setState({
        selectedSticker: i
      })
    }
  }
  render () {
    const {
      categories,
      brands,
      stickers
    } = this.props
    return (
      <React.Fragment>
        <div className={cx('brand__nav mb1 pb1 x', {
          'fixed': this.state.fixed,
          'fixed bottom': this.state.bottom
        })}>
          <div className={cx('shadow__box brand__nav-main bcw x', {
            'hidden': this.state.query !== ''
          })}>
            <div className='f jcb aic'>
              <div onClick={() => this.shiftZone('category')} className={cx('brand__nav-block ac', {
                'active bcpur': this.state.active === 'category'
              })}>
                <span className='h5 medium caps block p05'>Category</span>
              </div>
              <div onClick={() => this.shiftZone('stickers')} className={cx('brand__nav-block ac', {
                'active bcpur': this.state.active === 'stickers'
              })}>
                <span className='h5 medium caps block p05'>Stickers</span>
              </div>
            </div>
            <div className='py05 brand__nav-inner'>
              <div className={cx('brand__nav-mobile px1 py05 f jcb aic', {
                'is-open': this.state.navOpen
              })} onClick={() => this.setState({ navOpen: !this.state.navOpen })}>
                <h5 className='medium caps m0 p0 cb'>Sort by {this.state.active}</h5>
                <MiniArrow className='mr1' />
              </div>
              {categories.map((cat, i) => (
                <span className={cx('block p1 h5 m0 ls brand__nav-item medium caps', {
                  'active': i === this.state.selectedCategory,
                  'mobile-close': !this.state.navOpen,
                  'hidden': this.state.active === 'stickers' || this.state.query !== ''
                })} onClick={() => jump(`.brand__${i}`)} key={cat.category}>{cat.category}</span>
              ))}
              {stickers.map((cat, i) => (
                <span className={cx('block p1 h5 m0 ls brand__nav-item medium caps', {
                  'active': i === this.state.selectedSticker,
                  'mobile-close': !this.state.navOpen,
                  'hidden': this.state.active === 'category' || this.state.query !== ''
                })} onClick={() => jump(`.sticker__${i}`)} key={cat.sticker}>{cat.sticker}</span>
              ))}
            </div>
          </div>
          <div className='shadow__box bcw mt1'>
            <form ref={this.form} className='search x rel z4' onSubmit={e => this.searchJazz(e)}>
              <input type='text' value={this.state.query} autoComplete='off' onClick={e => this.searchJazz(e)} onChange={e => this.searchJazz(e)} className='p15 x' name='search' id='search' placeholder='Search' />
              <button type='submit' className='abs y top right search__button'><Search /></button>
            </form>
          </div>
        </div>
        <div className={cx('brand__zone js-top-brand', {
          'fixed': this.state.fixed || this.state.bottom
        })} ref={this.brandNav}>
          {this.state.query !== '' && (
            <div>
              <h3 className='mt0 pt0'>Search results for: {this.state.query}</h3>
              <div className={cx('brand__card-grid f fw jcb ais')}>
                {this.state.results.map(result => {
                  const {data} = find(brands, {id: result.id})
                  return (
                    <div key={result.id} className='x'>
                      <PageLink to={`/brands/${data.slug.current}`}>
                        <div className='brand__card-image'>
                          <Image imageId={data.imageId} alt={data.title} width={400} />
                        </div>
                        <span className='s18 block py05'>{data.title}</span>
                      </PageLink>
                    </div>
                  )
                })}
                <div className='x' />
                <div className='x' />
              </div>
            </div>
          )}
          {categories.map((cat, i) => (
            <div key={i} className={cx('mb15 pb15 brand__zone-block', cat.category.toLowerCase(), `brand__${i}`, {
              'is-active': this.state.active === 'category',
              'is-searching': this.state.query !== ''
            })}>
              <VisibilitySensor onChange={e => this.handleCategory(e, i)} partialVisibility offset={{top: 200, bottom: 200}}>
                {({isVisible}) => (
                  <div>
                    <h2 className='mt0 pt0'>{cat.category}</h2>
                    <div className={cx('brand__card-grid f fw jcb ais')}>
                      {cat.brands.map(({ data }) => (
                        <div key={data.slug.current} className={cx('x', {
                          'is-searching': this.state.query !== ''
                        })}>
                          <PageLink to={`/brands/${data.slug.current}`}>
                            <div className='brand__card-image'>
                              <Image imageId={data.imageId} alt={data.title} width={400} />
                            </div>
                            <span className='s28 block pt0 brand__card-text pb05'>{data.title}</span>
                          </PageLink>
                        </div>
                      ))}
                      <div className='x' />
                      <div className='x' />
                    </div>
                  </div>
                )}
              </VisibilitySensor>
            </div>
          ))}
          {stickers.map((cat, i) => (
            <div key={i} className={cx('mb15 pb15 brand__zone-block', `sticker__${i}`, {
              'is-active': this.state.active === 'stickers',
              'is-searching': this.state.query !== ''
            })}>
              <VisibilitySensor onChange={e => this.handleSticker(e, i)} partialVisibility offset={{ top: 200, bottom: 200 }}>
                {({ isVisible }) => (
                  <div>
                    <div className='f jcb aic brand__zone-stickers'>
                      <h2 className='mt0 pt0'>{cat.sticker}</h2>
                      <Image className='sticker' width={200} imageId={cat.brands[0].data.mainSticker.imageId} alt={cat.brands[0].data.mainSticker.title} />
                    </div>
                    <div className={cx('brand__card-grid f fw jcb ais')}>
                      {cat.brands.map(({ data }) => (
                        <div key={data.slug.current} className={cx('x', {
                          'is-searching': this.state.query !== ''
                        })}>
                          <PageLink to={`/brands/${data.slug.current}`}>
                            <div className='brand__card-image'>
                              <Image imageId={data.imageId} alt={data.title} width={400} />
                            </div>
                            <span className='s28 block pt0 brand__card-text pb05'>{data.title}</span>
                          </PageLink>
                        </div>
                      ))}
                      <div className='x' />
                      <div className='x' />
                    </div>
                  </div>
                )}
              </VisibilitySensor>
            </div>
          ))}
        </div>
      </React.Fragment>
    )
  }
}

export default CategoriesZone